// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";
import { APP_BAR_HEIGHT, NAV_SIDEBAR_WIDTH } from "metabase/nav/constants";

interface AppBarRootProps {
  hasSidebarOpen?: boolean;
}

export const AppBarRoot = styled.div<AppBarRootProps>`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: ${APP_BAR_HEIGHT};
  padding-left: 1.325rem;
  padding-right: 1rem;
  position: relative;
  background-color: var(--mb-color-bg-white);
  box-shadow: 0 2px 8px ${color("shadow")};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${(props) => (props.hasSidebarOpen ? NAV_SIDEBAR_WIDTH : "0px")};
    background-color: var(--mb-color-brand);
    border-inline-end: 1px solid
      ${(props) => (props.hasSidebarOpen ? "black" : "transparent")};
    transition:
      width 0.4s cubic-bezier(0.22, 1, 0.36, 1),
      border-inline-end-color 0.4s cubic-bezier(0.22, 1, 0.36, 1);
    will-change: width;
    z-index: 0;
    pointer-events: none;
  }
`;

export const AppBarLeftContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 5rem;
  position: relative;
  z-index: 1;
`;

export const AppBarRightContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 1rem;
  max-width: 32.5rem;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
`;

interface AppBarInfoContainerProps {
  isVisible?: boolean;
}

export const AppBarInfoContainer = styled.div<AppBarInfoContainerProps>`
  display: flex;
  min-width: 0;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  transition: ${(props) =>
    props.isVisible ? `opacity 0.5s` : `opacity 0.5s, visibility 0s`};
`;

export const AppBarProfileLinkContainer = styled.div`
  color: var(--mb-color-text-light);
`;
